module.exports = __webpack_public_path__ + "static/media/3.dfe3cfa6.ogg";